"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    useOklchToRgb: ()=>useOklchToRgb
});
const external_react_namespaceObject = require("react");
const index_cjs_namespaceObject = require("../utils/index.cjs");
const colorCache = new Map();
const useOklchToRgb = ()=>{
    const convertCssVarToRgb = (0, external_react_namespaceObject.useCallback)((cssVarName)=>{
        if (!cssVarName.startsWith('--')) cssVarName = `--${cssVarName}`;
        if (colorCache.has(cssVarName)) return colorCache.get(cssVarName);
        const oklchValue = (0, index_cjs_namespaceObject.getCssVarValue)(cssVarName);
        const rgbValue = (0, index_cjs_namespaceObject.oklchToRgb)(oklchValue);
        colorCache.set(cssVarName, rgbValue);
        return rgbValue;
    }, []);
    const convertMultipleVars = (0, external_react_namespaceObject.useCallback)((cssVarNames)=>cssVarNames.map((varName)=>convertCssVarToRgb(varName)), [
        convertCssVarToRgb
    ]);
    const clearCache = (0, external_react_namespaceObject.useCallback)(()=>{
        colorCache.clear();
    }, []);
    const refreshCachedValue = (0, external_react_namespaceObject.useCallback)((cssVarName)=>{
        if (!cssVarName.startsWith('--')) cssVarName = `--${cssVarName}`;
        colorCache.delete(cssVarName);
        return convertCssVarToRgb(cssVarName);
    }, [
        convertCssVarToRgb
    ]);
    return {
        convertCssVarToRgb,
        convertMultipleVars,
        clearCache,
        refreshCachedValue
    };
};
exports.useOklchToRgb = __webpack_exports__.useOklchToRgb;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "useOklchToRgb"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
